module.exports = __webpack_public_path__ + "img/courseTip.23f63a59.png";